export default __webpack_public_path__ + "static/media/bigLogo.a32946a9.svg";